import React, { useState } from 'react';
//组件
import { Image,Button } from 'antd-mobile'
export default function WagesSubmitSucceed(props) {
    function handleFun(to) {
        to+='?&time='+Date.parse(new Date())
        props.history.push(to)
    }



    return (
        <div style={{width:'100%',textAlign:"center"}}>
            <Image src={require("assets/images/uploadSucceed.png")} width={"80%"} style={{marginTop:'64px'}} fit='fill'></Image>
            <div style={{color:"gray",marginTop:'64px'}}> 提交成功</div>
            <Button block
                    color='success'
                    size='large'
                    onClick={() => {
                        handleFun('/')
                    }}
                    style={{marginTop:'64px'}}>
                返回
            </Button>
        </div>
    );
}
